import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "./Components/ThemeProvider/ThemeProvider";
import Router from "./routes";
import BackToTopButton from "./Components/BacktoTop/BackToTopComp";
import HeaderComp from "./Components/HeaderComp/HeaderComp";
import FooterComp from "./Components/FooterComp/FooterComp";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <HeaderComp />

      <BrowserRouter>
        <Router />
      </BrowserRouter>

      <FooterComp />
      <BackToTopButton />
    </ThemeProvider>
  );
}

export default App;
